import { render } from "./ClaimDeviceForm.vue?vue&type=template&id=541af56e"
import script from "./ClaimDeviceForm.vue?vue&type=script&lang=js"
export * from "./ClaimDeviceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__